import React from 'react';
import { Users, Search, User } from 'lucide-react';

const RoleUserList = ({ users, roleName, loading }) => {
    return (
        <div className="bg-[#1a1a1a] border border-white/10 rounded-xl overflow-hidden shadow-lg h-full flex flex-col">
            <div className="p-4 border-b border-white/10 bg-[#252525] flex justify-between items-center">
                <h3 className="text-lg font-semibold text-white flex items-center gap-2">
                    <Users className="w-5 h-5 text-blue-500" />
                    Kullanıcılar
                </h3>
                {roleName && <span className="text-xs font-mono text-gray-400 bg-white/5 px-2 py-1 rounded">{roleName}</span>}
            </div>

            <div className="flex-1 overflow-y-auto p-4 custom-scrollbar">
                {!roleName ? (
                    <div className="h-full flex flex-col items-center justify-center text-gray-500 opacity-60">
                        <Users className="w-12 h-12 mb-3" />
                        <p>Kullanıcıları görüntülemek için bir rol seçin</p>
                    </div>
                ) : loading ? (
                    <div className="h-full flex flex-col items-center justify-center text-gray-400">
                        <div className="animate-spin w-6 h-6 border-2 border-blue-500 border-t-transparent rounded-full mb-2"></div>
                        <p>Kullanıcılar yükleniyor...</p>
                    </div>
                ) : users.length === 0 ? (
                    <div className="h-full flex flex-col items-center justify-center text-gray-500 opacity-60">
                        <p>Bu role sahip kullanıcı bulunmuyor</p>
                    </div>
                ) : (
                    <div className="grid gap-2">
                        {users.map((user) => (
                            <div
                                key={user.id}
                                className="flex items-center gap-3 p-3 bg-[#1e1e1e] border border-white/5 rounded-lg hover:border-white/10 transition-colors"
                            >
                                <div className="w-8 h-8 rounded-full bg-blue-500/10 flex items-center justify-center text-blue-500 text-xs font-bold uppercase">
                                    {user.username?.substring(0, 2) || '??'}
                                </div>
                                <div className="flex-1 min-w-0">
                                    <p className="text-sm font-medium text-white truncate">{user.username}</p>
                                    {user.email && <p className="text-xs text-gray-500 truncate">{user.email}</p>}
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default RoleUserList;
